import {AppUserProvider} from "contexts/AppUserContext";
import {AuthProvider} from "contexts/AuthContext";
import {ChallengesCacheProvider} from "contexts/ChallengesCacheContext";
import {LayoutProvider} from "contexts/LayoutContext";
import {LocationProvider} from "contexts/LocationContext";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import type {ReactNode} from "react";

interface Props {
  children: ReactNode;
}

function AppContexts({children}: Props) {
  return (
    <AuthProvider>
      <AppUserProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <LocationProvider>
            <ChallengesCacheProvider>
              <LayoutProvider>{children}</LayoutProvider>
            </ChallengesCacheProvider>
          </LocationProvider>
        </LocalizationProvider>
      </AppUserProvider>
    </AuthProvider>
  );
}

export default AppContexts;
